import { useScrollReveal, animStyle } from '../../../hooks/useScrollReveal';

export default function Footer() {
  const { ref, visible } = useScrollReveal(0.3);

  return (
    <footer className="w-full bg-[#111111] py-8 px-5 sm:px-8 md:px-20" ref={ref}>
      <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
        <img
          src="https://static.wixstatic.com/media/a314f7_845f62e0a1f24abca7a449a8f2d689fb~mv2.png/v1/fill/w_226,h_83,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/%E7%99%BD%E6%8A%9C%E3%81%8D.png"
          alt="Groove Gravity"
          className="h-8 w-auto object-contain opacity-70"
          style={animStyle(visible, 'fromLeft', 0, 700)}
        />
        <p
          className="text-white/40 text-xs tracking-wider"
          style={animStyle(visible, 'fromRight', 150, 700)}
        >
          &copy; 2018 by Groove Gravity, Inc. &nbsp; All Rights Reserved.
        </p>
      </div>
    </footer>
  );
}
